export const EVENT_PREFIX = 'fake-door-';
export const TEST_CONSENT_MANAGER_ID = [
  '4c07e435-7edc-4cad-955a-e1b3ce4522cc', // marina.garcia.mobgen@gmail.com
  'dafaecb0-c844-4225-a365-234ba9a85eab', // joel+manager@whalar.com (manager) [dev]
  '9ccf3e29-aa15-4e75-97a0-75181e20e010', // Giacomo (manager) [dev]
  'a2d62572-8a61-48b8-bfeb-4684f596da97', // amy.thomas@sixteenth.com (manager) [prod]
  '30152af7-74db-4a08-b658-73f5475b9a3e', // rj.thorpe@sixteenth.com (manager) [prod]
  '815152af-40ff-4ec3-9a31-47226d2a3fdb', // steph.lechman@sixteenth.com (manager) [prod]
  '63f94283-56ef-4b6a-8858-09229fd4cae0', // talia.phillips@sixteenth.com (manager) [prod]
  'c8811044-4e2a-47d0-8df3-d99071c57478', // megan.frantz@sixteenth.com (manager) [prod]
];
